import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from 'vuex-shared-mutations'
import * as Cookies from 'js-cookie'

import Authentication from './modules/authentication'
import Events from './modules/events'
import Locations from './modules/locations'
import Notifications from './modules/notifications.js'
import Alert from './modules/alert.js'
import User from './modules/user'
import Host from './modules/host'
import Other from './modules/other'
import Admin from './modules/admin'
import createLogger from './util/logger'

import * as TYPE from '~/store/util/types'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const VuexPlugins = [
	createMutationsSharer({
		predicate: [
			TYPE.SET_USER,
			TYPE.SET_HOST,
			TYPE.SET_USER_PROP,
			TYPE.SET_VISITOR_LOCATION,
			TYPE.SET_ALL_EVENTS,
			TYPE.SET_EVENT_PROP,
			TYPE.ADD_EVENT,
			TYPE.SET_ALL_LOCATIONS,
			TYPE.ADD_LOCATION,
			TYPE.SET_LOCATION_PROP,
			// Host
			TYPE.SET_ADD_EVENT_PROP,
			TYPE.ADD_EVENT_RESET_STATE,
			TYPE.ADD_LOCATION_RESET_STATE
		]
	}),
	createPersistedState({
		key: 'application_data',
		// storage: {
		// 	getItem: key => Cookies.get(key),
		// 	setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: true }),
		// 	removeItem: key => Cookies.remove(key)
		// },
		paths: [
			'Host.host',
			'Host.event',
			'Host.location',
			'Authentication.authRedirect',
			'Authentication.host'
		]
	})
]

const createStore = new Vuex.Store({
	modules: {
		Authentication,
		Events,
		Locations,
		Notifications,
		Alert,
		User,
		Host,
		Other,
		Admin
	},
	strict: debug,
	plugins: debug
		? [
			...VuexPlugins
			// createLogger()
		]
		: [...VuexPlugins]
})

export default createStore
